module.exports = __webpack_public_path__ + "static/stats@2x-d77b64a167a44d6de574c0e79a31ad1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/mode/stats@2x.jpg
// module id = 403
// module chunks = 3627797113349 20562973939449 33019919093843